module.exports = __webpack_public_path__ + "static/img/volkswagen-cs-education.75c02f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/volkswagen-cs-education.jpg
// module id = Rpwj
// module chunks = 0